/**
 * AAA IDP locality reducer
 * Set the state of the user from the home page form
 * 
 */
import { DELETE, LOCALITY } from '../../actions/types';
import { STATE_CLUB } from '../../data/Data';
export const initialState = {
  club: '',
  error: false,
  required: true,
  valid: null,
  value: ''
};
export default function (state = initialState, action) {
  switch (action.type) {
    case DELETE:
      return initialState;
    case LOCALITY:
      {
        let {
          required
        } = state;
        const {
          value
        } = action;
        const valid = value === '' && required ? false : true;
        const club = value ? STATE_CLUB[value] : '';
        return {
          club,
          error: !valid,
          required,
          valid,
          value
        };
      }
    default:
      return state;
  }
}